<div class="container">

  <div class="row">
    <div class="col-12">
      @if (!fallbackRecipients) {
        <h6 class="text-center routeEditGroupTitle mb-2">{{'RECIPIENTS' | translate}}
        </h6>
      }
      @if (fallbackRecipients) {
        <h6 class="text-center routeEditGroupTitle mb-2">{{'FALLBACK_RECIPIENTS'| translate}}</h6>
      }
    </div>
  </div>

  <!-- Available recipients -->
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-12 white-bg">
      <div class="card card-borders p-2">
        <h6 class="text-center recipientGroupTitle">{{'AVAILABLE_RECIPIENTS' | translate }}</h6>

        <mat-list>
          @for (group of availableRecipientGroups | keyvalue; track group) {
            @if (group.value.availableRecipients.length > 0) {
              <mat-list-item class="mb-3 location-item">
                <div class="recipient-row">
                  <div>
                    @if (group.value.locationName) {
                      <span class="fa-fw mr-2 fa-solid fa-house recipientGroupTitle"></span>
                    }
                    <span class="recipientGroupTitle">
                      {{group.value.locationName}}
                      {{group.value.translationSuffix | translate }}
                    </span>
                  </div>
                  <mat-icon
                    class="add-recipient-button"
                                  (click)="addRecipientsByTypeAndLocationId(
                                    group.value.availableRecipients[0].locationId,
                                    group.value.availableRecipients[0].type,
                                    group.key
                                  )"
                    >
                    add_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
            @for (recipient of group.value.availableRecipients; track recipient) {
              <mat-list-item class="mb-3">
                <div class="recipient-row">
                  <div>
                    <div [ngClass]="{'selected-recipient-opacity' : recipient.selected}">
                      <span [ngClass]="recipient.type | recipientTypeIcon"></span>
                      <span class="recipient-name">{{recipient.name}} ({{recipient.id}})</span>
                    </div>
                    @if (recipient.type === 'USER') {
                      <div [ngClass]="{'selected-recipient-opacity' : recipient.selected}">
                        <span class="fa-light fa-phone fa-fw"></span>
                        <span> {{recipient?.gsmNumber || '-'}}</span>
                      </div>
                    }
                  </div>
                  <mat-icon class="add-recipient-button"
                    [ngClass]="{'selected-recipient-opacity' : recipient.selected}"
                    (click)="addRecipient(recipient); scrollToBottom('selected-recipients');">add_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
            <mat-divider></mat-divider>
          }
        </mat-list>
      </div>
    </div>

    <!-- Selected recipients -->
    <div class="col-lg-5 col-md-12 white-bg">
      <div class="card card-borders p-2">
        <h6 class="text-center recipientGroupTitle">{{ 'SELECTED_RECIPIENTS' | translate }}</h6>

        <mat-list dense="true" id="selected-recipients">
          <div cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
            @for (recipient of selectedRecipientsList; track recipient; let idx = $index) {
              <mat-list-item
                class="mb-3 selected-recipient-container"
                [@addRecipientAnimation]="addedAnimation"
                cdkDrag
                >
                <div class="recipient-row" matListItemTitle>
                  <div class="d-flex flex-column">
                    <div>
                      <span [ngClass]="recipient.type | recipientTypeIcon"></span>
                      <span class="recipient-name">{{recipient.name}} ({{recipient.id}})</span>
                    </div>
                    @if (recipient.type === 'USER') {
                      <div class="text-truncate">
                        <span class="fa-light fa-phone fa-fw"></span>
                        <span> {{recipient?.gsmNumber || '-'}}</span>
                      </div>
                    }
                  </div>
                  <div *cdkDragPreview class="drag-preview">
                    <span [ngClass]="recipient.type | recipientTypeIcon"></span>
                    {{recipient.name}} ({{recipient.id}})
                    {{idx}}
                  </div>
                  <div class="drag-placeholder" *cdkDragPlaceholder></div>
                  <mat-icon class="remove-recipient-button" (click)="removeRecipient(idx)">
                    remove_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
          </div>
        </mat-list>
      </div>
    </div>
  </div>
</div>
